import {setAuthData} from '@utils/auth.js'

const AUTH_UPDATE_EVENTS = ['auth:updated', 'auth-updated']

export function broadcastAuthUpdate() {
  if (typeof window === 'undefined') return

  AUTH_UPDATE_EVENTS.forEach((eventName) => {
    try {
      window.dispatchEvent(new Event(eventName))
    } catch {
      // ignore browsers without Event constructor support
    }
  })
}

export function clearAuthSession({broadcast = true} = {}) {
  if (typeof window === 'undefined') return false

  let hadAuth = false

  try {
    hadAuth = !!localStorage.getItem('auth')
  } catch {
    return false
  }

  if (hadAuth) {
    setAuthData(null)
  }

  if (broadcast && hadAuth) {
    broadcastAuthUpdate()
  }

  return hadAuth
}
